import {DataFetcher} from '@aboutyou/data-fetcher';
import {COLORS} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {RequestFailure} from '../shared/RequestFailure';
import {CoinsHistoryPageSkeleton} from './CoinsHistoryPageSkeleton';
import {CoinsHistoryPageView} from './CoinsHistoryPageView';
import {useCoinsHistory} from './hooks/useCoinsHistory';

export const CoinsHistoryPage = (props: {
  continuationToken?: string;
  loadNextPage: VoidFunction;
  updateNextToken: (token: string | null) => void;
}) => {
  return (
    <DataFetcher
      request={useCoinsHistory(props.updateNextToken, props.continuationToken)}
      Error={() => <StyledRequestFailure />}
      Loading={CoinsHistoryPageSkeleton}
      View={CoinsHistoryPageView}
      viewProps={{onInView: props.loadNextPage}}
    />
  );
};

const StyledRequestFailure = styled(RequestFailure)`
  height: 100%;
  background-color: ${COLORS.Grey4};
  padding-top: 8rem;
`;
